import { render, staticRenderFns } from "./pickdmain.vue?vue&type=template&id=931f6e20&scoped=true"
import script from "./pickdmain.vue?vue&type=script&lang=js"
export * from "./pickdmain.vue?vue&type=script&lang=js"
import style0 from "./pickdmain.vue?vue&type=style&index=0&id=931f6e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "931f6e20",
  null
  
)

export default component.exports